/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whatsapp_Bot_Link_Jid_TakenInputs */

const he_whatsapp_bot_link_jid_taken = /** @type {(inputs: Whatsapp_Bot_Link_Jid_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מספר הווטסאפ הזה כבר מקושר לחשבון pricedrop אחר.`)
};

const en_whatsapp_bot_link_jid_taken = /** @type {(inputs: Whatsapp_Bot_Link_Jid_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This WhatsApp number is already linked to another pricedrop account.`)
};

/**
* | output |
* | --- |
* | "This WhatsApp number is already linked to another pricedrop account." |
*
* @param {Whatsapp_Bot_Link_Jid_TakenInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const whatsapp_bot_link_jid_taken = /** @type {((inputs?: Whatsapp_Bot_Link_Jid_TakenInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whatsapp_Bot_Link_Jid_TakenInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_whatsapp_bot_link_jid_taken(inputs)
	return en_whatsapp_bot_link_jid_taken(inputs)
});